import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";

const navItems = [
  { name: "Tiling", path: "/workspace/tilings" },
  { name: "Patterning", path: "/workspace/patterning" },
  { name: "Styling", path: "/workspace/styling" },
];

export function WorkspaceLayout() {
  const location = useLocation();

  return (
    <div className="drawer lg:drawer-open">
      <input id="main-drawer" type="checkbox" className="drawer-toggle" />

      <div className="drawer-content">
        <main className="p-4 lg:p-6 bg-base-100">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
